import React, {useEffect, useState } from "react";
import { getAllAttendances } from "../../utils/helper";
import Loader from "../../utils/Loader";
import moment from "moment";

export default function AllAttendance() {
    const [attendances, setMyAttendances] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [myData, setMyData] = useState(null);
    const [date, setDate] = useState(null);

    useEffect(() => {
        setLoading(true);
        getAllAttendances()
            .then((res) => { 
                if(res.data.success){
                    setMyAttendances(res.data.data);  
                }
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            })
            .catch((err) => { 
                console.log(err.response)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
    }, []);

    const handleChangeDate = (e) => {
        e.persist();
        setSelectedDate(e.target.value);
    };

    useEffect(() => {
        if(selectedDate && attendances !== null){

            const data = attendances.filter((item) => {
                if (selectedDate !== null) {
                    let date = moment(selectedDate).format("MMMM Do YYYY");
                    setDate(date);
                    return (
                        item.date.toString().toLowerCase().indexOf(date.toLowerCase()) !== -1
                    );
                } else {
                    return item;
                }
            })
            setMyData(data);
        }
    }, [selectedDate, attendances]);

    return (
        <>
            {/* <div className="spur-card-menu"><button onClick={()=> {}} className="pull-right btn topbtn btn-primary">CHANGE VIEW</button></div> */}
            
            <h1 className="dash-title">Attendance Management</h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">

                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">All Attendances For <span className="text-danger">{date}</span></div>
                            <div className="spur-card-menu">
                                <input 
                                    type="date" 
                                    value={moment(selectedDate).format("YYYY-MM-DD")} 
                                    className="form-control form-select" 
                                    required
                                    onChange={handleChangeDate} 
                                />
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {(!loading && myData && myData) ?  <>
                                    <div className="table-responsive">
                                        {(myData && myData.length > 0) ? 
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr>
                                                <th>SN</th>
                                                <th>Staff</th>
                                                <th>Date</th>
                                                <th>ClockIn Location</th>
                                                <th>Latitude</th>
                                                <th>Longitude</th>
                                                <th>Week</th>
                                                <th>TimeIn</th>
                                                <th align="center">TimeOut</th>
                                            </tr></thead>
                                            <tbody>
                                                {myData && myData.map((row, index) => 
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            {row.employee && row.employee?.first_name} {row.employee && row.employee?.last_name}
                                                        </td>
                                                        <td>{row?.date && row?.date}</td>
                                                            <td>
                                                                {row.location && row.location}
                                                            </td>
                                                            <td align="center">
                                                                {row.latitude && row.latitude}
                                                            </td>
                                                            <td align="center">
                                                                {row.longitude && row.longitude}
                                                            </td>
                                                            <td>
                                                                {row.week}
                                                            </td>
                                                            <td><span className={row.timeIn >= "8:30:00 AM" ? `badge badge-danger` : `badge badge-success`}>
                                                                {row.timeIn} </span>
                                                            </td>
                                                            <td>{row.timeOut ? row.timeOut : "-- • --"}
                                                            </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table> : 
                                        <div className="alert alert-danger myerror d-block">No Attendance record was found for this day.</div> }
                                    </div>
                                    </>
                                : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
